import React, { memo } from 'react';
import { motion } from 'framer-motion';
import { SlideLayout, itemVariants } from '../ui/SlideLayout';
const rows = [{
  label: 'Reprogrammability',
  asic: 'None — frozen at fab',
  fpga: 'Full — gates reconfigure',
  gpu: 'Software only'
}, {
  label: 'Power Efficiency',
  asic: 'Best',
  fpga: 'Very high',
  gpu: 'Moderate–High'
}, {
  label: 'Memory Architecture',
  asic: 'Fixed, custom',
  fpga: 'Custom hierarchies (BRAM/URAM)',
  gpu: 'Shared HBM, virtual memory'
}, {
  label: 'Latency Determinism',
  asic: 'Cycle-level',
  fpga: 'Cycle-level',
  gpu: 'Non-deterministic (driver scheduling)'
}, {
  label: 'NRE Cost',
  asic: '$5M–$100M+',
  fpga: 'Near zero',
  gpu: 'Near zero'
}, {
  label: 'Time to New Model',
  asic: 'Months–years (new chip)',
  fpga: 'Days–weeks (recompile)',
  gpu: 'Hours–days (software)'
}, {
  label: 'Peak Performance',
  asic: 'Highest',
  fpga: '~90% of ASIC',
  gpu: 'High (batch-dependent)'
}, {
  label: 'Low-Batch Efficiency',
  asic: 'Excellent',
  fpga: 'Excellent',
  gpu: 'Poor (70–80% idle)'
}];
export function AppendixA1Slide() {
  return <SlideLayout data-id="element-13">
      <motion.div variants={itemVariants} className="mb-10" data-id="element-14">
        <p className="text-brand-teal font-mono text-xs tracking-widest uppercase mb-3" data-id="element-15">
          Appendix A1
        </p>
        <h2 className="text-3xl md:text-4xl font-bold text-brand-text" data-id="element-16">
          FPGA vs GPU vs ASIC — Technical Deep Dive
        </h2>
      </motion.div>

      <motion.div variants={itemVariants} className="overflow-x-auto" data-id="element-17">
        <table className="w-full text-sm" data-id="element-18">
          <thead data-id="element-19">
            <tr className="border-b border-brand-border" data-id="element-20">
              <th className="text-left py-3 pr-4 text-brand-text-muted font-medium w-1/4" data-id="element-21"></th>
              <th className="text-left py-3 px-4 text-brand-text-dim font-semibold" data-id="element-22">
                ASIC
              </th>
              <th className="text-left py-3 px-4 text-brand-teal font-semibold" data-id="element-23">
                FPGA
              </th>
              <th className="text-left py-3 px-4 text-brand-text-dim font-semibold" data-id="element-24">
                GPU
              </th>
            </tr>
          </thead>
          <tbody data-id="element-25">
            {rows.map((row, i) => <tr key={row.label} className="border-b border-brand-border/50" data-id="element-26">
                <td className="py-3 pr-4 text-brand-text font-medium" data-id="element-27">
                  {row.label}
                </td>
                <td className="py-3 px-4 text-brand-text-dim" data-id="element-28">{row.asic}</td>
                <td className="py-3 px-4 text-brand-text bg-brand-teal/5" data-id="element-29">
                  {row.fpga}
                </td>
                <td className="py-3 px-4 text-brand-text-dim" data-id="element-30">{row.gpu}</td>
              </tr>)}
          </tbody>
        </table>
      </motion.div>

      <motion.div variants={itemVariants} className="mt-8 flex gap-4 text-xs text-brand-text-muted" data-id="element-31">
        <span data-id="element-32">
          References: FlightLLM benchmarks, Goldman Sachs AI Infrastructure
          Report
        </span>
      </motion.div>
    </SlideLayout>;
}